import styled from 'styled-components'
import colors from '../../tokens/colors'
import fonts from '../../tokens/fonts'
import typography from '../../tokens/typography'
import layout from '../../tokens/layout'
import { ContainerAnimation as Animation } from '../table/styles'

export const Container = styled.div`
  position: relative;
`

export const Footer = styled.div`
  align-items: center;
  background-color: ${colors.neutralColorHighMedium};
  border: 0.1rem solid ${colors.neutralColorLowLight};
  color: ${colors.neutralColorLowDark};
  display: flex;
  flex-direction: row;
  font-family: ${fonts.inter};
  justify-content: space-between;
  line-height: 2.1rem;
  margin-bottom: 2rem;
  padding: 1.6rem 2.4rem;
  text-align: center;
`

export const PaginationContainer = styled.div`
  display: flex;
  align-items: center;
  font-size: ${typography.fontSize.fontSizeXxs};
`

export const SelectContainer = styled.div`
  margin-left: 0.8rem;
  margin-right: ${layout.margin.spacingQuarck};
`

export const PagesContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  color: ${colors.neutralColorLowLight};
  margin: 0 0 0 0.5rem;
  div {
    color: ${colors.neutralColorLowLight};
    padding: ${layout.padding.spacingInsetNano};
  }
  .inactive {
    background-color: transparent;
    color: ${colors.neutralColorLowMedium};
    cursor: pointer;
  }
`

export const ChildrenContainer = styled.div`
  margin-right: 0.5rem;
`

export const PageButton = styled.span`
  color: ${colors.neutralColorLowLight};
  padding: ${layout.padding.spacingInsetQuarck};
`

export const ContainerAnimation = styled(Animation)`
  pointer-events: none;
`
